/* eslint-disable no-console */
import React from 'react';

import { Box } from 'components/@ux/box';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.log('ErrorBoundary >> error', error);
    console.log('ErrorBoundary >> errorInfo', errorInfo);
    this.setState((state) => ({ ...state, hasError: true }));
  }

  render(): JSX.Element | React.ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Box centeredContent height="100vh">
          <Box display="flex" flexDirection="column" alignItems="center" width="80%">
            <Box fontSize="2.7rem" fontWeight={700}>
              Algún error ha ocurrido durante el render de la app.
            </Box>
            <Box fontSize="1.5rem" fontWeight={600} mt="2rem" textAlign="center">
              Nuestro equipo esta trabajando para resolver el problema. Por favor recargue la página
              y si el problema persiste póngase en contacto con nuestro equipo de desarrollo
            </Box>
          </Box>
        </Box>
      );
    }

    return children;
  }
}

export { ErrorBoundary };
